import React from 'react';
import './homePage.css'
import CarbonCarousel from '../../components/CarbonCarousel/CarbonCarousel';
import Head from '../../components/Head/Head';
import HeadCard from '../../components/Cards/HeadCard';
import SecondCard from '../../components/Cards/SecondCard';
import SiteFooter from '../../components/footer/Sitefooter';
import CenterCard from '../../components/center/CenterCard';
import ProductCard from '../../components/ProductCards/ProductCard';
import Screen1 from "../../assets/images/screen1.png"
import Screen2 from "../../assets/images/screen2.png"
import Store from "../../assets/images/store.png"
import Play from "../../assets/images/play.png"
import Art3 from "../../assets/images/Art3.png"
import Art2 from "../../assets/images/Art2.png"
import Art1 from "../../assets/images/Art1.png"
import Product from '../../components/Products/product';
import 'animate.css';

import { Button, Container, Row, Col } from 'react-bootstrap';

const HomePage = () =>{
  return (
    <div className="container-fluid p-0 m-0">
      <div className="header">
        <Head /> 
      </div>
      <div className="mt-5">
        <CenterCard />    
      </div>
      <div className="container mt-5">
        <div className="row">
          <div className="mb-4 mt-5">
            <HeadCard />
            <div className='d-flex flex-row justify-content-center mt-1 mb-2'>
            <Button className="m-1 button-87">
              <a href='https://accounts.netikash.com' target="_blank" style={{fontSize:16, lineHeight:2, textDecoration:'none', color:'white'}}>CREEZ VOTRE COMPTE NETIKASH </a>
            </Button>
            </div>
          </div>
          <div className="">
            <div className='mb-5 mt-5'>
              <SecondCard 
                image={Art1}
                titre='NETIKASH PAY'
                description="
                Netikash Pay est une plateforme de traitement des paiements électroniques.  Avec Netikash Pay vous pouvez :
                  Effectuer des dépôts et des retraits dans votre wallet chez tous nos agents
                  Effectuer et recevoir des paiements électroniques partout en RDC. 
                  Envoyer et recevoir des transferts d’argent partout en RDC
                "
                action="Accédez a Netikash Pay" href='https://dashboard.netikash.com'
              />
            </div>
            <div className='mb-5 mt-5'>
              <Product 
                image={Art3}
                 titre='NETIKASH PAYME'
                 description="
                 Netikash Payme vous permet de facilement et rapidement vendre vos services sur internet. Vous n’avez qu’à créer votre page de paiement pour commencer à générer des revenus.
                 "
                 action="Accédez a Netikash Payme" href='https://payme.netikash.com'
              />
            </div>
            <div className='mb-5 mt-5'>
              <SecondCard 
                image={Art2}
                 titre='NETIKASH SUBSCRIBE'
                 description="
                 Netikash Subscribe est votre plateforme idéale pour la gestion de vos abonnements. Créez vos pages d’abonnements et partagez-les avec vos clients pour vous assurer des revenus récursifs permanents.
                 "
                 action="Accédez a Netikash Subscribe" href='https://subscribe.netikash.com'
              />
            </div>
          </div>
        </div>
      </div>
      <Container className="p-0 duval mb-5">
      <h3 className="w-100 position-relative mb-5" style={{ color: '#430C05', fontWeight: 'bold', fontSize: 30, textAlign: 'start', marginLeft: 10 }}>
      Lancez-vous avec les applications mobiles Netikash 
      </h3>
      <Row className="position-relative w-100" style={{ bottom: 0 }}>
        <Col xs={12} md={6} lg={4}>
            <ProductCard title="01" subtitle="Téléchargez nos applications" image1={Play} image2={Store}>
          <p style={{ color: "#333333" }}>
          Téléchargez les applications Netikash sur Google Play Store pour Android ou sur Apple Store pour iOS
            </p>
          </ProductCard>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <ProductCard title="02" subtitle="Créez votre compte en quelques minutes" image3={Screen2}>
          <p>
          Créez votre compte Netikash unique en quelques minutes et accédez à toutes nos applications..
            </p>
          </ProductCard>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <ProductCard title="03" subtitle="Utilisez Netikash Pay" image4={Screen1}>
          <p>
              Avec votre compte Netikash, vous pouvez effectuer vos transactions financières en toute sécurité.
            </p>
          </ProductCard>
        </Col>
      </Row>
    </Container>
    <div className='container p-0'>
      <CarbonCarousel />
    </div>
        <SiteFooter />
    </div>
  )
};

export default HomePage;